
import { ReactNode, useRef } from "react";
import { inputOnKeyUp } from "../../functions.ts";
import { useStore } from "../../state/state.ts";
import './info-button.css';

export default function InfoButton(props:{label?: string, modal: ReactNode}){
    const ref = useRef<HTMLButtonElement>(null);
    const push_modal = useStore((state) => state.push_modal_closeable);
    return <button 
        ref={ref}
        className="info-button-container"
        onClick={()=>{push_modal(props.modal,ref);}}
        onKeyDown={(event)=>inputOnKeyUp(event, ()=>{push_modal(props.modal, ref);})}
        role="button"
        aria-label={"weitere informationen zu "+props.label}
        tabIndex={0}
    >
        <span role="presentation" className="info-button">i</span>
    </button>
}